import React from "react";
import { useLocation } from "react-router-dom";
import "../HTMate/HTMate.scss";
import Terms from "./Terms";
import PrivacyAndPolicy from "./PrivacyAndPolicy";
import Cookies from "./Cookies";

const FooterDetails = () => {
  const location = useLocation();

  // Get the last part of the URL
  const lastPart = location.pathname.split("/").pop();

  const renderContent = () => {
    switch (lastPart) {
      case "termsAndConditions":
        return <Terms />;
      case "privacyAndPolicy":
        return <PrivacyAndPolicy />;
      case "cookies":
        return <Cookies />;
      default:
        return <div>Page not found</div>;
    }
  };

  return (
    <div
      className="data-container"
      // style={{
      //   backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
      // }}
    >
      {renderContent()}
    </div>
  );
};

export default FooterDetails;
